import type { Unit } from '@yawi/types';

export function formatUnitLabel(unit: Pick<Unit, 'name' | 'tower' | 'number' | 'floor' | 'block'>): string {
  const main = unit.name?.trim() || unit.number || '';
  const tower = unit.tower ? `Torre ${unit.tower}` : null;
  return [tower, main].filter(Boolean).join(' · ') || 'Unidad';
}
